import store from '@/store/index'

export function isPerson () {
  const userType = store.state.user.userType
  if (!userType) return false
  return userType === '个人'
}

export function isLogin () {
  const ticket = store.state.user.ticket
  const token = store.state.user.token
  return Boolean(ticket || token)
}

// zjzwfwcsqy 可测
export function judgeShouldGoGrayEnv (userInfo = {}) {
  const { grayFlag } = userInfo
  if (!grayFlag) return

  let urlQuery = ''
  if (isPerson()) {
    urlQuery = `?gxdjpersonkey=${store.state.user.token}`
  } else {
    urlQuery = `?gxdjkey=${store.state.user.ticket}`
  }
  window.location.replace(process.env.VUE_APP_GRAY_URL + window.location.pathname + urlQuery)
}
